var map = {
	"./music/bassoon.wav": 51,
	"./music/cello.wav": 52,
	"./music/clarinet.wav": 53,
	"./music/flute.wav": 54,
	"./music/french_horn.wav": 55,
	"./music/guitar.wav": 56,
	"./music/harp.wav": 57,
	"./music/oboe.wav": 58,
	"./music/piano.wav": 59,
	"./music/piccolo.wav": 60,
	"./music/saxophone.wav": 61,
	"./music/snare.wav": 62,
	"./music/timpani.wav": 63,
	"./music/trombone.wav": 64,
	"./music/trumpet.wav": 65,
	"./music/tuba.wav": 66,
	"./music/viola.wav": 67,
	"./music/violin.wav": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;